// effect -> facade.create -> api call
// facade.create -> dispatch action ->reducer  -> effect -> api -> dispatch action

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RewardsProgramApiService } from '../../services/rewards-program-api.service';
import {
  CreateRewardsProgramPreference,
  CreateRewardsProgramPreferenceFail,
  CreateRewardsProgramPreferenceSuccess,
  GetRewardsProgramPreference,
  GetRewardsProgramPreferenceFail,
  GetRewardsProgramPreferenceSuccess,
} from '../actions/rewards-program-preference.actions';

@Injectable()
export class RewardsProgramEffects {
  constructor(
    private actions$: Actions,
    private rewardsProgramApiService: RewardsProgramApiService,
  ) {}

  createRewardsProgramPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateRewardsProgramPreference),
      switchMap(({ rewardsProgramId }) =>
        this.rewardsProgramApiService
          .createRewardsProgramPreference(rewardsProgramId)
          .pipe(
            map((rewardsProgramPreference) => {
              return CreateRewardsProgramPreferenceSuccess({
                rewardsProgramPreference,
              });
            }),
            catchError((error: HttpError) =>
              of(CreateRewardsProgramPreferenceFail({ error })),
            ),
          ),
      ),
    ),
  );

  getRewardsProgramPreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetRewardsProgramPreference),
      switchMap(() =>
        this.rewardsProgramApiService.getRewardsProgramPreference().pipe(
          map((rewardsProgramPreference) => {
            return GetRewardsProgramPreferenceSuccess({
              rewardsProgramPreference,
            });
          }),
          catchError((error: HttpError) =>
            of(GetRewardsProgramPreferenceFail({ error })),
          ),
        ),
      ),
    ),
  );
}
